import FieldWrapper from '../fieldWrapper';
import CleanRestrictedInput from '../../cleanRestrictedInput';

export const ReduxFormCleanAlphabet = FieldWrapper(CleanRestrictedInput('text', /[^a-zA-Z \-'.,"]/g));
